import { render, staticRenderFns } from "./changeType.vue?vue&type=template&id=51fec01c&scoped=true&"
import script from "./changeType.vue?vue&type=script&lang=js&"
export * from "./changeType.vue?vue&type=script&lang=js&"
import style0 from "./changeType.vue?vue&type=style&index=0&id=51fec01c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fec01c",
  null
  
)

export default component.exports